/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PostLoginResponse,
  SaveElectronicsContactsRequest,
} from '../models/index';
import {
    PostLoginResponseFromJSON,
    PostLoginResponseToJSON,
    SaveElectronicsContactsRequestFromJSON,
    SaveElectronicsContactsRequestToJSON,
} from '../models/index';

export interface SaveElectronicsContactsObjectIdPostRequest {
    saveElectronicsContactsRequest?: SaveElectronicsContactsRequest;
}

export interface SaveElectronicsContactsPostRequest {
    saveElectronicsContactsRequest?: SaveElectronicsContactsRequest;
}

/**
 * 
 */
export class PostLoginApi extends runtime.BaseAPI {

    /**
     * Put confirmation of electronic contacts for the current user.
     */
    async confirmContactsPutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/post-login/confirm-contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Put confirmation of electronic contacts for the current user.
     */
    async confirmContactsPut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmContactsPutRaw(initOverrides);
    }

    /**
     * Get initial, post login, actions for the current user.
     */
    async getPostLoginInfoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostLoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/post-login`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostLoginResponseFromJSON(jsonValue));
    }

    /**
     * Get initial, post login, actions for the current user.
     */
    async getPostLoginInfoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostLoginResponse> {
        const response = await this.getPostLoginInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Post electronic contacts for the current user.
     */
    async saveElectronicsContactsObjectIdPostRaw(requestParameters: SaveElectronicsContactsObjectIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/save-electronics-contacts-object-id`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveElectronicsContactsRequestToJSON(requestParameters['saveElectronicsContactsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post electronic contacts for the current user.
     */
    async saveElectronicsContactsObjectIdPost(requestParameters: SaveElectronicsContactsObjectIdPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveElectronicsContactsObjectIdPostRaw(requestParameters, initOverrides);
    }

    /**
     * Post electronic contacts for the current user.
     */
    async saveElectronicsContactsPostRaw(requestParameters: SaveElectronicsContactsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/post-login/save-electronics-contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveElectronicsContactsRequestToJSON(requestParameters['saveElectronicsContactsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post electronic contacts for the current user.
     */
    async saveElectronicsContactsPost(requestParameters: SaveElectronicsContactsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveElectronicsContactsPostRaw(requestParameters, initOverrides);
    }

}
